// var CryptoJS = require("crypto-js");
import CryptoJS from "crypto-js";

let appId='songdao20200430'
let secret = 'lawsuitsMaster20220613'
let code = '059f5c7f669aec1bf56067f7cf1248bb'


function aesEncrypt(time) {
	let content = appId + '/' + code + '/' + time
	// console.log(content)
	const srcs = CryptoJS.enc.Utf8.parse(content);
	const encrypted = CryptoJS.AES.encrypt(srcs, CryptoJS.MD5(secret), {
		iv: [],
		mode: CryptoJS.mode.ECB,
		padding: CryptoJS.pad.Pkcs7
	});
	// console.log(encrypted.toString())
	return encrypted.toString();
}
// aesDecrypt(content, secret) {
// 	//content为密文，无需做处理即可
// 	const decrypt = CryptoJS.AES.decrypt(content, CryptoJS.MD5(secret), {
// 		iv: [],
// 		mode: CryptoJS.mode.ECB,
// 		padding: CryptoJS.pad.Pkcs7
// 	});
// 	const decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
// 	console.log(decryptedStr.toString())
// 	return decryptedStr.toString();
// },
// aesEncrypt(new Date().getTime())
export {
	// aesDecrypt,
	aesEncrypt
}



// WEBPACK FOOTER //
// ./src/utils/newAes.js